
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  setup () {
    const store = useStore()
    const shouldSetDate = computed(() => store.getters.shouldSetDate)

    return {
      shouldSetDate
    }
  }
})
